
import { DiscountCode } from "@/models/discount-code";
import { DiscountCodeService } from "@/services/discount-code-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			code: new DiscountCode(),
		};
	},
	computed: {
		title():string{
			if (this.$route.params.id == ""){
				return "Nieuwe kortingscode";
			}
			return "Kortingscode bewerken";
		}
	},
	methods: {
		setInfiniteUses(event:boolean){
			if (event){
				this.code.uses = -1;
			}else{
				this.code.uses = 1;
			}
		},
		async submit(){
			this.validate();
			if (!this.isValid) return;
			if (this.code.id == 0){
				this.code = await DiscountCodeService.createDiscountCode(this.code);
			}else{
				this.code = await DiscountCodeService.updateDiscountCode(this.code);
			}
			this.$router.push("/discount-code");
		}
	},
	async created(){
		let id = parseInt(this.$route.params.id || "0");
		if (id > 0){
			this.code = await DiscountCodeService.getDiscountCode(id);
		}
		this.validators.push(()=>{
			return this.code.from.getTime() < this.code.till.getTime();
		});
		this.validate();
	}
});
